enum UpdateStatus {
    Success = 1,
    Loading = 2,
    Error = 3,
    NotUploaded = 4
};

export default UpdateStatus;
